import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import authgear from "../authgear";

const DEV_NAV_ITEMS = [
  { label: "Management Agent", path: "/marketing" },
  { label: "Assets", path: "/assets" },
  { label: "Costs", path: "/costs" },
  { label: "Render", path: "/render" },
];

const PERSONAL_NAV_ITEMS = [
  { label: "Home", path: "/home" },
  { label: "Finance", path: "/finance" },
  { label: "Pokémon Showdown", path: "/showdown" },
  { label: "Calorie Tracker", path: "/calories" },
];

const ATHLETICS_NAV_ITEMS = [
  { label: "Weight Lifting", path: "/lift" },
  { label: "Workout Plan JSON", path: "/workout-plan" },
];

const RARELY_USED_NAV_ITEMS = [
  { label: "Job History", path: "/jobs" },
  { label: "Cron Jobs", path: "/cron" },
  { label: "Bluesky", path: "/bluesky" },
  { label: "LED Mask", path: "/mask" },
  { label: "FTP Log", path: "/ftp" },
  { label: "Races", path: "/races" },
  { label: "Add Future Workouts", path: "/workout" },
];

const NavMenu = ({ label, items, navigate }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleNav = (path) => {
    setOpen(false);
    navigate(path);
  };

  return (
    <div className="site-header__nav" ref={ref}>
      <button className="site-header__menu-btn" onClick={() => setOpen(o => !o)}>
        {label}
      </button>
      {open && (
        <div className="site-header__dropdown">
          {items.map(item => (
            <button key={item.path} className="site-header__dropdown-item" onClick={() => handleNav(item.path)}>
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const redirectURI = process.env.NODE_ENV === "production"
      ? "https://peter-lee-gifford.com/"
      : "http://localhost:3000/";
    await authgear.logout({ redirectURI });
    window.location.replace("/");
  };

  return (
    <header className="site-header">
      <div className="site-header__menus">
        <NavMenu label="Dev Tools" items={DEV_NAV_ITEMS} navigate={navigate} />
        <NavMenu label="Personal" items={PERSONAL_NAV_ITEMS} navigate={navigate} />
        <NavMenu label="Athletics" items={ATHLETICS_NAV_ITEMS} navigate={navigate} />
        <NavMenu label="Rarely Used" items={RARELY_USED_NAV_ITEMS} navigate={navigate} />
      </div>
      <button className="site-header__logout" onClick={handleLogout}>
        Logout
      </button>
    </header>
  );
};

export default Header;
